import React, { useState, useEffect, useRef } from 'react';
import { Panel } from "react-resizable-panels";
import * as serverApi from '../apis/server-api';
import * as offlineApi from '../apis/offline';
import { FaPlus } from "react-icons/fa6";
import * as ListItemCreator from './list-items';
import toast from 'react-hot-toast';

const LibraryList = ({currentData, centerContent, setData, refreshTrigger, editRef, isOnline}) => {
    const [libraryItems, setLibraryItems] = useState([]);
    const handleLibraryClick = (playlist) => {
        console.log('Clicked playlist: ' + playlist.name);
        setData(playlist);
        centerContent('playlist');
    }
    const createPlaylist = async() => {
        toast.error('Not available in demo.')
    }
    const loadPlaylists = async () => {
        if (isOnline) {
            const data = await serverApi.getLibrary();
            setLibraryItems(data);
            return data;
        } else {
            const data = await offlineApi.getLibrary();
            setLibraryItems(data);
            return data;
        }
        
    };
    useEffect(() => {
        async function update() {
            const playlists = await loadPlaylists();

            if (currentData._id) {
                const result = playlists.find(playlist => playlist._id === currentData._id);
                setData(result);
            }
        }
        update();
    }, [refreshTrigger]);

    return (
        <Panel defaultSize={30} minSize={'30%'} className="panel" collapsible={true}>
            <h2>Library</h2> 

            {libraryItems.length > 0 ? libraryItems.map((playlist) => <ListItemCreator.CreateLibraryItem key={playlist._id || playlist.name} playlist={playlist} callback={handleLibraryClick} />) : <p> No playlists yet. Try creating one! </p>}
        
            <button className="NewPlaylistButton" onClick={createPlaylist}> <FaPlus /> New Playlist </button>
        </Panel>
    );
}

export default LibraryList;